<template>
  <div class="text-center">
    <div class="login">
      <Navbar />
      <div class="container my-5">
        <div class="row mt-2">
          <div class="col-md-3"></div>
          <div class="col-md-6 text-center">
            <img src="../../public/logo.png" class="my-5" alt="" width="50%" />
            <div class="card">
              <div class="card-body">
                <i class="fas fa-lock fa-2x lock"></i>

                <form @submit.prevent="newPassreset">
                  <b-input
                    v-model="newpass"
                    required
                    type="password"
                    placeholder="New Password"
                  ></b-input>
                  <b-input
                    v-model="confirmpass"
                    required
                    type="password"
                    class="mt-2"
                    placeholder="Confirmed Password"
                  ></b-input>

                  <b-button
                    type="submit"
                    class="btn btn-primary btn-block mt-3"
                    variant="primary"
                    >Confirm</b-button
                  >
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <!-- <b-card style="width:50vw" class="ml-auto mr-auto">
      <form @submit.prevent="newPassreset">
          <b-input v-model="newpass" required type="password" placeholder="New Password"></b-input>
          <b-input v-model="confirmpass" required type="password" class="mt-2" placeholder="Confirmed Password"></b-input>
          
          <b-button variant="primary" type="submit">Confirm</b-button>
      </form> -->

    <!-- <h5>{{value}}</h5> -->
    <!-- </b-card> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PasswordReset",
  data() {
    return {
      confirmpass: "",
      newpass: "",
      isSuccess: false,
      value: "Verifying your account",
    };
  },
  created() {},
  methods: {
    async newPassreset() {
      let self = this;
      if (this.newpass == this.confirmpass) {
        console.log("dobule ducker");
        axios
          .post(
            "https://us-central1-provider-admin-panel.cloudfunctions.net/updatePassword",
            {
              uid: this.$route.params.id,
              password: this.newpass,
            }
          )
          .then((response) => {
            console.log(response);

            alert("Password updated");
            this.$router.push("/");
            this.$store.commit("setNotifications", {
              message: "Password updated successfully",
              type: "success",
            });
          })
          .catch((error) => {
            console.log(error);
            self.value = "Error verifying";
            this.$store.commit("setNotifications", {
              message: error,
              type: "error",
            });
          });
      } else {
        this.$store.commit("setNotifications", {
          message: "Both password fields should be same",
          type: "error",
        });
      }
    },
  },
};
</script>

<style>
</style>